import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import { NavLink } from "react-router-dom";

function Searchnav() {
  return (
    <>
      <div role="region" aria-label="skip navigation">
        <a href="#main" class="cmp-skip-link">
          Skip to main content
        </a>
        {/* <a href="#footer" class="cmp-skip-link">Skip to footer</a> */}
      </div>

      <div className="logo-bar-container">
        <div className="container">
          <div className="header">
            <div className="brandLogo">
              <div className="brandImage">
                <img
                  tabIndex={0}
                  src={process.env.PUBLIC_URL + "/images/Acc_Logo.png"}
                  alt="accenture-Log-Img"
                  className="accenture-logo-img img-responsive"
                />
              </div>
              <div className="header-title desktop-tag" tabIndex={0}>
                <span className="header-title-1">
                  Learning & Talent Transformation
                </span>
                <p className="desktop-tag-1" style={{ color: "#3C0060" }}>
                  ATC Global Network Learning
                </p>
              </div>
              <p class="mobile-tag">
                <span>LTT</span> <br />{" "}
                <p className="mobile-tag-1" style={{ color: "#3C0060" }}>
                  ATCGN
                </p>
              </p>
              <div className="header-title-home">
                <span className="header-title-2">
                  <NavLink to="/home">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/home-icon-purple.png"
                      }
                      alt="Home-Icon"
                    />
                  </NavLink>
                </span>
              </div>
            </div>

            <div className="user-detail">
              <WelcomeName />
              <img
                src={process.env.PUBLIC_URL + "/images/Avatar.png"}
                alt="avatar-icon"
                className="avatar-img"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
